module.exports = __webpack_public_path__ + "static/media/register-background.c53c0ef7.png";